import { FC } from "react";

import { EnvVariablesColumnId } from "components/Environment/constants/envVariableTable";
import { TableContext } from "components/Table/Context";
import { useDrawerVisibilityForId } from "ds/components/DrawerNew/useDrawerVisibilityForId";
import TableBodyRow from "ds/components/Table/Row";
import TableCell from "ds/components/Table/Row/Cell";
import useTypedContext from "hooks/useTypedContext";
import { ConfigElementWithSource } from "types/generated";

import DescriptionCell from "../Cells/DescriptionCell";
import NameCell from "../Cells/NameCell";
import SourceCell from "../Cells/SourceCell";
import TimestampCell from "../Cells/TimestampCell";
import ValueCell from "../Cells/ValueCell";
import { VariableCellComponentProps } from "../Cells/types";

type VariablesRowProps = {
  config: ConfigElementWithSource;
  actionsComponent?: FC<VariableCellComponentProps>;
};

const CELLS = {
  [EnvVariablesColumnId.NAME]: NameCell,
  [EnvVariablesColumnId.DESCRIPTION]: DescriptionCell,
  [EnvVariablesColumnId.VALUE]: ValueCell,
  [EnvVariablesColumnId.SOURCE]: SourceCell,
  [EnvVariablesColumnId.CREATED_AT]: TimestampCell,
  [EnvVariablesColumnId.ACTIONS]: undefined,
};

const VariablesRow = ({ config, actionsComponent }: VariablesRowProps) => {
  const rowId = config.element.id;
  const { visibleColumnIds } = useTypedContext(TableContext);
  const isActive = useDrawerVisibilityForId(rowId);

  if (!config.element) {
    return null;
  }

  return (
    <TableBodyRow isActive={isActive}>
      {visibleColumnIds.map((id) => {
        const Component = CELLS[id as EnvVariablesColumnId] ?? actionsComponent;

        if (!Component) {
          return null;
        }

        const uniqueKey = `${id}-${rowId}`;
        return (
          <TableCell key={uniqueKey} id={id}>
            {Component && (
              <Component
                variable={config.element}
                context={config.context}
                stackDependency={config.stackDependency}
              />
            )}
          </TableCell>
        );
      })}
    </TableBodyRow>
  );
};

export default VariablesRow;
